module.exports = __webpack_public_path__ + "static/media/Delivery Information.26e02351.jpg";